<template>
  <v-dialog v-model="dialog" max-width="100%">
    <v-card>
      <v-toolbar :color="dialogColor" dark
        ><h4>Datos de la Tarea</h4></v-toolbar
      >
      <v-card-text>
        <div class="text-h6 pa-12">
          Desea Finalizar Parcialmente la tarea o desea Suspender la tarea?
        </div>
        <v-text-field
          v-model="observacionModel"
          label="Observaciones (Opcional)"
          dense
        ></v-text-field>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
          title="Finalizar Parcialmente"
          color="blue"
          dark
          @click="finalizarParcialmente()"
          ><v-icon>mdi-clock-end</v-icon>Finalizar Parcialmente</v-btn
        >
        <v-btn title="Suspender" color="green" dark @click="suspender()"
          ><v-icon>mdi-pause-octagon-outline</v-icon>Suspender</v-btn
        >
        <v-btn title="Cerrar" color="red" dark @click="dialog = false"
          ><v-icon>mdi-close-circle</v-icon>Cerrar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    dialog: false,
    dialogColor: "",
    datosTarea: [],
    observacionModel: null,
  }),

  methods: {
    abrirDialog(item) {
      console.log("Los items son: ");
      console.log(item);
      this.datosTarea = item;
      this.dialog = true;
      this.dialogColor = "orange";
      console.log("Los datos del usuario son: ");
      console.log(this.$store.getters.usuario);
    },

    async finalizarParcialmente() {
      this.url =
        this.$store.getters.urlBase + "Task/finalizarParcialmenteTarea";

      const tarea = {
        idTarea: this.datosTarea.idTarea,
        observacion: this.observacionModel,
        idUsuario: this.$store.getters.usuario.user_id,
      };

      console.log("Los parametros son:");
      console.log(tarea);

      axios.post(this.url, tarea).then((response) => {
        console.log("Las respuesta de ingresa cuadrilla es: ");
        console.log(response.data);
        if (response.data == false) {
          this.$refs.dialogMensaje.abrirMensajeDialog(
            "Ya existe un remito con el mismo numero",
            1,
            "red",
            "Aviso"
          );
        } else {
          this.$refs.dialogCuadrilla.abrirCuadrillaDialog(
            "Operacion Exitosa",
            1,
            "green",
            "Ok"
          );
        }
        this.otMantenimiento = response.data;
      });
    },

    suspender() {
      this.url = this.$store.getters.urlBase + "Task/suspenderTarea";

      const tarea = {
        idTarea: this.datosTarea.idTarea,
        observacion: this.observacionModel,
        idUsuario: this.$store.getters.usuario.user_id,
      };

      console.log("Los parametros son:");
      console.log(tarea);

      axios.post(this.url, tarea).then((response) => {
        console.log("Las respuesta de ingresa cuadrilla es: ");
        console.log(response.data);
        if (response.data == false) {
          this.$refs.dialogMensaje.abrirMensajeDialog(
            "Ya existe un remito con el mismo numero",
            1,
            "red",
            "Aviso"
          );
        } else {
          this.$refs.dialogCuadrilla.abrirCuadrillaDialog(
            "Operacion Exitosa",
            1,
            "green",
            "Ok"
          );
        }
        this.otMantenimiento = response.data;
      });
    },
  },
};
</script>
